<template>
  <div class="wrn-input wrn-rounded search-input__bordered noborder">
    <div
      id="icon-left"
      class="wrn-addon"
      :style="{ backgroundColor: inputColor }"
    >
      <BaseIcon icon="ic_search" :colors="iconColor" width="24" height="24" />
    </div>
    <input
      ref="search"
      type="text"
      class="wrn-p-05 wrn-color-gray-1 search-input"
      :placeholder="placeholder"
      :value="value"
      :style="{ backgroundColor: inputColor }"
      @input="$emit('input', $event.target.value)"
      @keyup.enter="onEnterPress"
    />
    <div
      v-if="$slots.rightIcon"
      class="wrn-addon"
      :style="{ backgroundColor: inputColor }"
    >
      <slot name="rightIcon" />
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { BaseIcon } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component({
  components: { BaseIcon }
})
export default class SearchInput extends Vue {
  @Prop({ type: String, default: 'Buscar' })
  private placeholder!: string;

  @Prop({ type: String, default: NebraskaColors.textAlpha })
  private inputColor!: string;

  @Prop({ type: String, default: NebraskaColors.textPlaceholder })
  private iconColor!: string;

  @Prop({ type: String })
  private value!: string;

  // tslint:disable-next-line:no-empty
  @Prop({ type: Function, default: () => {} })
  private onEnterPress!: () => {};

  @Prop({ type: Boolean, default: false })
  private isFocus!: boolean;

  @Ref()
  private search!: HTMLInputElement;

  private NebraskaColors = NebraskaColors;
  private setFocus() {
    this.$nextTick(() => this.search.focus());
  }

  private created() {
    if (this.isFocus) {
      this.setFocus();
    }
  }
}
</script>

<style lang="less" scoped>
.search-input {
  outline: none;
}
.search-input__bordered {
  border: 1px solid @divider-primary;
}
</style>
